export var downloadFromLink = function (_a) {
    var url = _a.url, downloadName = _a.downloadName;
    var link = document.createElement('a');
    link.href = url;
    link.download = downloadName;
    link.click();
};
